<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Boston Light</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head1"><a id="page_5">C<span class="small">ONTENTS</span></a></p><a id="page_5">
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter1#C1" title="Link target outside of Sample">The First 200 Years</span></td></tr>
<tr><td><span href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter2#C2" title="Link target outside of Sample">Lighthouse Keeping</span></td></tr>
<tr><td><span href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter3#C3" title="Link target outside of Sample">Transition Years, 1950–1959</span></td></tr>
<tr><td><span href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter4#C4" title="Link target outside of Sample">1960 and Beyond</span></td></tr>
<tr><td colspan="2"><span href="#/Bibliography#Bib" title="Link target outside of Sample">Bibliography</span></td></tr>
<tr><td colspan="2"><span href="#/Index#Idx" title="Link target outside of Sample">Index</span></td></tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5400f778